import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import NavigationArrowBack from 'material-ui-legacy/svg-icons/navigation/arrow-back'

const BackButton = props => (
  <RaisedButton
    style={props.style || { margin: '5px' }}
    onTouchTap={props.onTouchTap || (() => window.history.back())}
    label={props.label || 'Go Back'}
    labelPosition="after"
    secondary={true}
    icon={<NavigationArrowBack />}
    {...props}
  />
)

export default BackButton



// WEBPACK FOOTER //
// ./src/components/UI/BackButton.jsx